import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Simple placeholder component to use while a feature is still under construction.
 */
@Component({
    selector: 'phms-not-implemented',
    imports: [RouterLink],
    templateUrl: './not-implemented.component.html',
    styleUrls: ['./not-implemented.component.scss']
})
export class NotImplementedComponent { }
